import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './Header.css';

function Header({
  userName,
  onLogout,
  onProfileClick,
  role,
  isPanelOpen,
  togglePanel,
  onMobileMenuToggle,
}) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <header className="top-header">
        {/* Mobile Menu Button */}
        {isMobile && onMobileMenuToggle && (
          <button
            className="mobile-menu-btn"
            onClick={onMobileMenuToggle}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'transparent',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              padding: '8px',
              borderRadius: '6px',
              transition: 'background 0.2s ease'
            }}
            onMouseEnter={(e) => e.target.style.background = '#e6ebf5'}
            onMouseLeave={(e) => e.target.style.background = 'transparent'}
          >
            ☰
          </button>
        )}
        <div className="header-center">
          STEMA Furniture
        </div>
        <div className="header-right" onClick={togglePanel}>
          <span className="profile-icon">👤</span>
        </div>
      </header>

      {isPanelOpen && createPortal(
        <div className="profile-panel">
          <div className="profile-panel-content">
            <div className="profile-panel-title">
              {userName}
            </div>
            <button className="profile-panel-btn primary" onClick={onProfileClick}>
              View Profile
            </button>
            <button className="profile-panel-btn danger" onClick={onLogout}>
              Logout
            </button>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}

export default Header;
